import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Switch, Typography } from 'antd';
import React, { memo, useState } from 'react';

import TaxonomyCategoriesPreview from './CategoriesPreview';
import TaxonomyCategoriesTree from './CategoriesTree';

import './styles.scss';

const { Text } = Typography;

const TaxonomyCategories = (props) => {
  const [previewMode, setPreviewMode] = useState(false);
  const [previewFilters, setPreviewFilters] = useState([]);

  return (
    <div className="ant-pro-grid-content categories-content">
      <div className="categories-content-tree-container">
        <TaxonomyCategoriesTree
          preview={previewMode}
          onPreviewCategoryChange={setPreviewFilters}
        />
      </div>
      <div className="categories-content-preview-container">
        <div className="categories-content-preview">
          {!previewMode && (
            <div className="categories-content-preview-switch">
              <Text className="categories-content-preview-switch-label">
                Preview mode
              </Text>
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                defaultChecked={previewMode}
                onChange={setPreviewMode}
              />
            </div>
          )}
          {previewMode && (
            <TaxonomyCategoriesPreview
              onPreviewChange={setPreviewMode}
              previewFilters={previewFilters}
            />
          )}
        </div>
      </div>
    </div>
  );
};

TaxonomyCategories.propTypes = {};

TaxonomyCategories.defaultProps = {};

export default memo(TaxonomyCategories);
